module.exports = __webpack_public_path__ + "static/media/Panther356_1c.bc5383f7.svg";